
export default {
    name: "the-terms",
    components: {
    },
    props: {
        isMounted: {
            type: Boolean,
            required: true,
        },
        layout: {
            required: false,
            default: 'chain',
            type: String
        },
        previousForm: {
            type: String,
            required: false,
            default: 'select_screen'
        }
    },
    data() {
        return {
            vippsIcon: require("../../../assets/img/Vipps-Logo.png"),
        };
    },
    methods: {
        changeView(state) {
            this.$emit("changeView", state);
        },
    },
};
